"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.IdxImage = void 0;

var _react = require("react");

var _localforage = _interopRequireDefault(require("localforage"));

var IdxImage = function IdxImage(props) {
  var _useState = (0, _react.useState)(null),
      image = _useState[0],
      setImage = _useState[1];

  (0, _react.useEffect)(function () {
    _localforage.default.getItem(props.src).then(function (value) {
      setImage(value);
    }).catch(function (err) {
      console.error(err);
    });
  }, [props.src]);
  return props.children({
    image: image
  });
};

exports.IdxImage = IdxImage;
var _default = IdxImage;
exports.default = _default;